import React from "react";
import {
  getFullName,
  getLocalPhoneNumber,
} from "../../../components/util/helpers";
import { useIntl } from "react-intl";
import { IonLabel, IonItem, IonIcon, IonBadge } from "@ionic/react";
import {
  phonePortraitOutline,
  callOutline,
  alertCircleOutline,
} from "ionicons/icons";

import moment from "moment";

const SchedulingItem = (props) => {
  const { item } = props;
  const intl = useIntl();
  const startDate = moment()
    .startOf("day")
    .set("minute", item.start_time_minutes);
  const end = moment()
    .startOf("day")
    .set("minute", item.duration_minutes + item.start_time_minutes);
  const timeframe = startDate.format("HH:mm") + "-" + end.format("HH:mm");

  const mobile =
    item.employee &&
    item.employee.contact_info &&
    item.employee.contact_info.mobile_number &&
    getLocalPhoneNumber(item.employee.contact_info.mobile_number);

  const phone =
    item.employee &&
    item.employee.contact_info &&
    item.employee.contact_info.phone_number &&
    getLocalPhoneNumber(item.employee.contact_info.phone_number);
  const mobileOrPhone = mobile || phone;

  return (
    <IonItem
      key={item.id}
      detail={mobileOrPhone}
      lines="none"
      href={mobileOrPhone ? `tel:${mobileOrPhone}` : null}
    >
      <IonIcon
        icon={
          mobile
            ? phonePortraitOutline
            : phone
            ? callOutline
            : alertCircleOutline
        }
        slot="start"
      />
      <div style={{ padding: "6px 0" }}>
        <IonLabel>
          {item.employee &&
            item.employee.first_name &&
            `${getFullName(item.employee.surename, item.employee.first_name)}`}
        </IonLabel>
        {mobileOrPhone && <IonLabel color="medium">{mobileOrPhone}</IonLabel>}
        <IonLabel color="medium">
          {`${timeframe} - ${item.order.client.name}`}
        </IonLabel>
      </div>
      {moment().day() === item.weekday && (
        <IonBadge color="success" slot="end">
          {intl.formatMessage({
            id: "app.mobile.today",
          })}
        </IonBadge>
      )}
    </IonItem>
  );
};

export default SchedulingItem;
